import { defineStore } from "pinia";

export interface ReportsState {
  selectedQuestionnareId: string;
  selectedContextId: string;
  selectedQuestionnaireLabel: string;
  selectedReceiverCompanyName: string;
}

export const useReportViewStore = defineStore("reportViewStore", {
  state: () => ({
    selectedQuestionnareId: "",
    selectedQuestionnaireLabel: "",
    selectedContextId: "",
    selectedReceiverCompanyName: "",
  }),
});